module.exports = __webpack_public_path__ + "img/box.67901875.svg";